import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const AttributesQuery = gql`
  query attributes {
    attributes {
      id
      title
      isVisual
      name
      tags
      slug
      priority
      definition
      type
      values {
        id
        title
        slug
        value
        colorHex
      }
    }
    languages {
      id
      value
    }
  }
`;

const CreateAttributeMutation = gql`
  mutation create(
    $title: String!
    $type: String!
    $isVisual: Boolean
    $definition: JSON
    $tags: [String!]
    $name: JSON!
    $slug: JSON!
    $priority: Int
    $values: [AttributeValueInput]!
  ) {
    createAttribute(
      attribute: {
        type: $type
        title: $title
        values: $values
        name: $name
        tags: $tags
        slug: $slug
        priority: $priority
        definition: $definition
        isVisual: $isVisual
      }
    ) {
      id
    }
  }
`;

const UpdateAttributeMutation = gql`
  mutation update(
    $id: String!
    $title: String!
    $type: String!
    $isVisual: Boolean
    $definition: JSON
    $name: JSON!
    $tags: [String!]
    $slug: JSON!
    $priority: Int
    $values: [AttributeValueInput]!
  ) {
    updateAttribute(
      id: $id
      attribute: {
        type: $type
        title: $title
        values: $values
        name: $name
        tags: $tags
        priority: $priority
        slug: $slug
        definition: $definition
        isVisual: $isVisual
      }
    ) {
      id
    }
  }
`;

const DeleteAttributeMutation = gql`
  mutation delete($id: String!) {
    deleteAttribute(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
}

class GetAttributesQuery extends React.Component<ChildProps<IInputProps, GQL.IQuery>, {}> {
  render() {
    return this.props.children(this.props);
  }
}

export default compose(
  graphql<IInputProps, GQL.IQuery>(AttributesQuery, {
    name: 'attributes'
  }),
  graphql<IInputProps, GQL.IQuery>(CreateAttributeMutation, {
    name: 'createAttribute'
  }),
  graphql<IInputProps, GQL.IQuery>(UpdateAttributeMutation, {
    name: 'updateAttribute'
  }),
  graphql<IInputProps, GQL.IQuery>(DeleteAttributeMutation, {
    name: 'deleteAttribute'
  })
)(GetAttributesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Attributes/Attributes.tsx